<template>
  <div class="data-import-dialog">
    <el-dialog
      :class="customClass"
      :visible.sync="visible"
      width="520px"
      :title="title"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :append-to-body="appendToBody"
      :show-close="ifShowClose"
      :before-close="cancel"
      :style="{
        fontSize: 'normal',
      }"
      @opened="opened()"
      @close="close()"
      @cancel="cancel()"
    >
      <el-form v-if="ifPass" class="zwx-form" style="padding: 0 !important;" key="mainForm" ref="mainForm" :model="mainForm" :rules="mainFormRule" label-position="right">
        <div class="edit-form" style="max-width: 392px; padding: 10px 0 0px 20px !important;height:40px">
          <el-form-item label-width="55px" label="密码：" prop="passWord">
            <el-input class="zwx-input data-input-password" style="width: 290px !important" v-model="mainForm.passWord" placeholder="请输入" maxlength="16" :type="newView ? 'password' : null">
              <i slot="suffix" :class="newView ? 'el-input__icon  outline chis-icon-outline-eye' : 'el-input__icon outline chis-icon-outline-eye-invisible'" @click="passSeeNew()"></i>
            </el-input>
          </el-form-item>
        </div>
      </el-form>

      <zwx-scrollbar-y class="dialog-scrollbar-y">
        <div class="data-import-dialog-body" :class="$zwxBase.verifyIsNotBlank(errorMsg) ? 'el-upload-dragger-error' : ''">
          <el-upload
            v-show="ifshowUpload"
            ref="msImportUpload"
            drag
            :multiple="multiple"
            :show-file-list="false"
            :accept="accept"
            :before-upload="beforeUpload"
            :on-change="change"
            :on-success="fileSubmitSuccess"
            :on-error="fileSubmitError"
            :on-progress="fileSubmitProgress"
            :file-list="showFileList"
            :auto-upload="false"
            :action="action"
            :data="paramData"
            :style="{
              fontSize: 'normal',
            }"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload-text"><em>点击上传</em></div>
            <div class="el-upload-text" style="width: 360px;color: #777F89;font-size: 12px">
              请先下载导入模板，按表格内要求填写信息后再上传表格文件，支持格式：xls、xlsx。
            </div>
          </el-upload>

          <div class="show-file-body" v-show="!ifshowUpload">
            <div class="show-file-box" @mouseenter="mouseenter()" @mouseleave="mouseleave()">
              <i class="filled chis-icon-filled-excel" style="color: #2AC47F"></i>
              <div class="file-name-text">
                <div>{{ fileName }}</div>
                <div style="margin-left: 5px">
                  <span class="el-upload-list__item check" :style="fileCheck ? 'margin-left:5px;display:none;' : 'margin-left:5px;cursor:pointer'">
                    <i class="el-icon-upload-success el-icon-circle-check"></i>
                  </span>
                  <span class="check" :style="fileCheck ? 'margin-left:5px;cursor:pointer' : 'margin-left:5px;display:none;'">
                    <i class="el-icon-close" @click="deletionFile()"></i>
                  </span>
                </div>
              </div>
            </div>
            <el-progress :percentage="parseFloat(percentage)" :stroke-width="4" :show-text="false" :color="exportState == 3 ? '#F1574E' : '#4A75F5'" define-back-color="#f1f4f8" style="margin-bottom:16px;"></el-progress>
            <div v-if="finished || uploading" class="tip-meesage">
              <i v-if="exportState != 0" :class="exportStateMap[exportState].icon" :style="{ color: exportStateMap[exportState].color }"></i>
              <span :style="{ color: exportStateMap[exportState].color }">{{ exportStateMap[exportState].title }}</span>
              <span v-if="exportState == 0" style="padding-left:10px;">{{ percentage }}%</span>
            </div>
            <div v-if="finished" style="margin-top:24px;text-align: center;" v-html="exportStateMap[exportState].textHtml"></div>
          </div>
          <div class="error-warn" v-if="$zwxBase.verifyIsNotBlank(errorMsg)">{{ errorMsg }}</div>
        </div>
      </zwx-scrollbar-y>

      <span v-if="ifFooter" slot="footer" style="display: flex; align-items: center; justify-content: space-between;">
        <div>
          <slot name="footer" />
        </div>
        <div style="width: 100%;margin-right: 20px;margin-left: 20px;display: flex;justify-content: space-between">
          <div>
            <el-button v-if="ifTempDownload" class="zwx-button zwx-button-text-32" icon="el-icon-download" @click="tempDownload">下载导入模板</el-button>
            <el-button v-if="[2, 3].includes(exportState)" class="zwx-button zwx-button-text-32" icon="el-icon-download" @click="openFilePreview(errorList, 0)">错误报告.xlsx</el-button>
          </div>
          <div>
            <!-- v-if="confirmContent" -->
            <el-button v-if="ifDetermine && !uploading && !finished" class="zwx-button zwx-button-32" type="primary" :loading="uploading" @click="determine()">导入</el-button>
            <el-button v-if="confirmContent" class="zwx-button zwx-button-32" type="danger" @click="confirmDialogDetermine()">{{ confirmContent }}</el-button>
            <el-button v-if="ifCancel && ![1, 2, 3].includes(exportState)" class="zwx-button zwx-button-32" @click="cancel()">取消</el-button>
            <el-button v-if="[1, 2, 3].includes(exportState)" class="zwx-button zwx-button-32" type="primary" @click="cancel()">确定</el-button>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ImportDialog',
  props: {
    title: { type: String, default: '' }, // 弹窗标题
    customClass: { type: String, default: '' },
    ifFooter: { type: Boolean, default: true },
    ifDetermine: { type: Boolean, default: true },
    ifCancel: { type: Boolean, default: true }, // 显示关闭弹窗按钮
    appendToBody: { type: Boolean, default: false },
    ifShowClose: { type: Boolean, default: true },
    ifTempDownload: { type: Boolean, default: true }, // 显示下载导入模板
    ifshowUpload: { type: Boolean, default: true },
    errorName: { type: String, default: '' },
    errorPath: { type: String, default: '' },
    ifPass: { type: Boolean, default: false }, // 需要输入密码
    action: { type: String, default: '', required: true }, // 上传文件接口地址
    accept: { type: String }, // 接受上传的文件类型
    multiple: { type: Boolean, default: false },
    size: { type: Number },
    sizeInfo: { type: String },
    paramData: {}, // 上传时附带的额外参数
    errorMsg: { type: String, default: '' },
    newView: { type: Boolean, default: true },
    // determineBtnDisabled: { type: Boolean, default: false },
  },
  data() {
    return {
      api: this.$store.state.api,
      file: this.$store.state.file,
      users: this.$store.state.users,
      mainFormRule: {
        passWord: [
          { required: true, message: '请输入密码', trigger: ['change', 'blur'] },
          { validator: this.validatePassword, trigger: ['change', 'blur'] },
        ],
      },
      visible: false,
      uploading: false, // 正在上传
      finished: false, // 上传结束
      status: false,
      percentage: 0,
      showFileList: [],
      fileName: '',
      fileCheck: '',
      mainForm: {
        passWord: '',
      },
      confirmContent: '', // 二次确认弹窗，内容
      confirmApi: '', // 二次确认弹窗，点击确认发送请求的接口地址
      exportStateMap: [
        { title: '导入进行中', color: '#777F89' },
        { title: '导入成功', color: '#15AD31', icon: 'el-icon-success', textHtml: '' },
        { title: '导入结束', color: '#FA8C15', icon: 'el-icon-success', textHtml: '' },
        { title: '导入失败', color: '#F1574E', icon: 'el-icon-error', textHtml: '' },
      ], //导入状态
      exportState: 0,
      errorList: [],
    }
  },
  created() {},
  methods: {
    mouseenter() {
      this.fileCheck = true
    },
    mouseleave() {
      this.fileCheck = false
    },
    confirmDialogDetermine() {
      if (this.confirmApi) {
        this.$emit('loading', true)
        this.$system.post(
          this.api + this.confirmApi,
          {},
          true,
          true,
          data => {
            if (data.type === '00') {
              this.$emit('loading', false)
              this.confirmContent = ''
              this.$system.notify('成功', data.mess, 'success')
              this.$emit('updateSuccess', data)
            } else if (data.type === '99') {
              this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
            } else {
              this.$notify.error({ title: '错误', message: data.mess })
            }
          },
          () => {
            this.$notify.error({ title: '错误', message: '网络连接失败' })
          }
        )
      }
    },
    /**
     * 文件预览
     */
    openFilePreview(fileList, index) {
      top.postMessage(
        {
          handlerType: 'previewFile',
          params: {
            fileList: fileList,
            index: index,
          },
        },
        '*'
      )
    },
    show(visible) {
      this.uploading = false
      this.finished = false
      this.percentage = 0
      this.confirmContent = ''
      this.confirmApi = ''
      this.visible = visible
    },
    passSeeNew() {
      this.newView = !this.newView
    },
    determine() {
      if (this.ifPass === true) {
        this.$refs.mainForm.validate(valid => {
          if (valid) {
            this.$emit('passWord', this.mainForm.passWord)
            this.$emit('determine')
          }
        })
      } else {
        this.$emit('determine')
      }
    },
    opened() {
      this.$emit('opened')
    },
    cancel() {
      this.exportState = 0
      this.uploading = false
      this.$emit('cancel')
    },
    close() {
      this.exportState = 0
      this.mainForm.passWord = ''
      this.visible = false
      this.uploading = false
      this.$emit('close')
    },
    tempDownload() {
      this.$emit('tempDownload')
    },
    change(file, showList) {
      //判定文件类型
      this.fileVaild = this.beforeUpload(file)
      if (this.fileVaild === true) {
        this.$emit('fileUrl', window.URL.createObjectURL(file.raw))
        this.fileName = file.name
        this.fileCheck = false
      }
      this.$emit('change', showList)
    },
    beforeUpload(file) {
      this.fileName = file.name
      let prefix = file.name.substring(file.name.lastIndexOf('.'))
      let isImg = this.accept.indexOf(prefix) != -1
      if (!isImg) {
        let acceptInfo = this.accept.replaceAll('.', '').replaceAll(',', '、')
        this.$system.notify('错误', '请上传格式为' + acceptInfo + '的文件', 'error')
      }
      let isLtSize = parseFloat(file.size) < this.size
      if (!isLtSize) {
        this.$system.notify('错误', '上传文件大小不能超过' + this.sizeInfo, 'error')
      }
      this.$emit('beforeUpload', isImg && isLtSize)
      return isImg && isLtSize
    },
    fileSubmit(uid) {
      this.confirmContent = ''
      this.confirmApi = ''
      this.$refs.msImportUpload.submit(uid)
    },
    fileSubmitSuccess(data) {
      if (data.type === '00') {
        this.getImportSchedule(data.scheduleUuid)
      } else if (data.type === '99') {
        this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
      } else {
        this.uploading = false
        this.finished = false
        this.percentage = 0
        this.$notify.error({ title: '错误', message: data.mess })
      }
    },
    fileSubmitError(data) {
      this.uploading = false
      this.$emit('fileSubmitError', data)
    },
    fileSubmitProgress() {
      this.uploading = true
    },
    /**
     * 获取导入进度
     * */
    getImportSchedule(uuid) {
      if (!this.visible) return
      if (!this.uploading) return
      let data = { uuid }
      this.$system.post(
        this.api + '/systematic/getImportScheduleFromCache-1',
        data,
        true,
        true,
        data => {
          if (data.type === '00') {
            const percentage = 100 * ((data.scheduleNum || 0) / data.totalNum).toFixed(2)
            this.percentage = this.transfPercentage(percentage)
            if ((data.scheduleNum || 0) < data.totalNum) {
              setTimeout(() => {
                this.getImportSchedule(uuid)
              }, 3000)
              this.exportState = 0 // 正在导入
            } else {
              this.uploading = false
              this.finished = true
              const { confirmContent, confirmApi, successNum, returnContent, errorName, errorPath } = data.result
              if (errorPath) {
                this.errorList = [{ fileName: errorName, filePath: errorPath }]
              }
              this.analysisMessage(successNum, data.totalNum, returnContent)
              this.confirmContent = confirmContent || ''
              this.confirmApi = confirmApi || ''
              this.$emit('fileSubmitSuccess', data)
            }
          } else if (data.type === '99') {
            this.$router.push({ name: 'ErrorPage', params: { mess: data.mess } })
          } else {
            this.uploading = false
            this.finished = false
            this.percentage = 0
            this.$notify.error({ title: '错误', message: data.mess })
          }
        },
        () => {
          this.$notify.error({ title: '错误', message: '网络连接失败' })
        }
      )
    },
    // 处理导入百分比
    transfPercentage(percentage) {
      let percentageStr = percentage + ''
      if (percentageStr.includes('.')) {
        return parseFloat(percentage.toFixed(2))
      } else {
        return percentage
      }
    },
    analysisMessage(successNum, total, returnContent) {
      let textHtml = ''
      if (successNum == total) {
        this.exportState = 1 //全部导入成功
        textHtml = `已成功导入<span style="color:#2A50D7;padding:0 4px">${successNum}</span>条数据，可通过导入记录功能查看记录`
      }
      if (successNum > 0 && successNum < total) {
        this.exportState = 2 // 部分导入成功
        textHtml = `已成功导入<span style="color:#2A50D7;padding:0 4px">${successNum}</span>条数据，
                                                          错误数据<span style="color:#FA8D17;padding:0 4px">${total - successNum}</span>条未导入，具体查看错误报告`
      }
      if (successNum == 0) {
        this.exportState = 3 // 全部导入失败
        textHtml = `导入数据失败，请重新上传`
      }
      this.exportStateMap[this.exportState].textHtml = returnContent || textHtml
    },
    deletionFile() {
      this.exportState = 0
      this.uploading = false
      this.finished = false
      this.percentage = 0
      this.confirmContent = ''
      this.confirmApi = ''
      this.$refs.msImportUpload.uploadFiles = []
      this.fileName = ''
      this.fileCheck = ''
      this.$emit('deletionFile')
    },
    // 子页面的校验方法，status用来判断是否校验成功
    validateHandle() {
      if (this.ifPass) {
        this.$refs['mainForm'].validate(val => {
          if (val) {
            this.status = true
          } else {
            this.status = false
          }
        })
      }
    },
    validatePassword(rule, value, callback) {
      if (value != undefined && value != null && value != '') {
        this.$validate.password(rule, value, callback)
      }
      callback()
    },
  },
}
</script>

<style lang="less" scoped>
.tip-meesage {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  i {
    margin-right: 6px;
  }
}
/deep/ .el-progress-bar__outer {
  border-radius: 0;

  .el-progress-bar__inner {
    border-radius: 0;
  }
}

.dialog-scrollbar-y .el-scrollbar__wrap {
  max-height: 64vh !important;
}

.el-upload-dragger-error .el-upload-dragger {
  border-color: #ff4949 !important;
}

.data-import-dialog {
  .tips-dialog {
    /deep/ .el-dialog {
      margin-top: 15vh !important;
    }
  }

  .show-file-body {
    width: 100%;
    padding: 24px;
  }

  .show-file-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 102px;
    // margin-bottom: 24px;
    background: #f9fbfd;
    padding-left: 36px;
    padding-right: 20px;
  }

  .file-name-text {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: calc(100% - 72px);
    font-size: 14px;
    font-weight: 400;
    color: #1f2d3d;
    margin-left: 24px;
  }

  .show-error-file-box {
    display: flex;
    align-items: center;
    width: 100%;
    height: 78px;
    background: #fff5f5;
    border: 1px solid #f6cccc;
    padding-left: 36px;
    padding-right: 20px;
  }
}

.data-import-dialog {
  /deep/ .el-dialog {
    min-width: 520px !important;
  }

  /deep/ .el-upload-dragger {
    width: 472px;
    height: 228px;
  }

  /deep/ .el-upload-dragger {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  /deep/ .el-upload-dragger em {
    color: #409eff;
  }
}

.data-import-dialog-body {
  height: 276px;

  .error-msg {
    padding: 0 10px;
    margin-left: 0 !important;
    color: #ff4949 !important;
    font-size: 12px !important;
    // line-height: 12px !important;
    font-weight: 400;
  }

  .error-warn {
    position: absolute;
    bottom: 0;
    padding-left: 20px;
    margin-left: 0 !important;
    color: #ff4949 !important;
    font-size: 12px !important;
    // line-height: 12px !important;
    margin-bottom: 3px;
  }

  > div:first-child {
    padding: 20px;
    height: 100%;
    width: 100%;
  }

  /deep/ .el-upload {
    width: 100%;
    height: 100%;
  }

  /deep/ .el-upload-text {
    margin-top: 18px;
  }
}
</style>
